import config from '../config/apiConfig';

const headers = () => ({
    'Content-Type': 'application/json',
    'token': localStorage.getItem('token') || '',
});

export const obtenerConfigFidelizacion = async () => {
    const res = await fetch(`${config.api_url}/api/fidelizacion/config`, { headers: headers() });
    const data = await res.json();
    if (!data.ok) throw new Error(data.msg || 'Error al obtener configuración');
    return data.data;
};

export const guardarConfigFidelizacion = async (payload) => {
    const res = await fetch(`${config.api_url}/api/fidelizacion/config`, {
        method: 'POST', headers: headers(), body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!data.ok) throw new Error(data.msg || 'Error al guardar');
    return data.data;
};

export const listarClubClientes = async ({ page = 1, q = '' } = {}) => {
    const params = new URLSearchParams({ page, q });
    const res = await fetch(`${config.api_url}/api/fidelizacion/clientes?${params}`, { headers: headers() });
    const data = await res.json();
    if (!data.ok) throw new Error(data.msg || 'Error al listar clientes');
    return data;
};

export const exportarClubClientes = async () => {
    const params = new URLSearchParams({ export: '1' });
    const res = await fetch(`${config.api_url}/api/fidelizacion/clientes?${params}`, { headers: headers() });
    const data = await res.json();
    if (!data.ok) throw new Error(data.msg || 'Error al exportar');
    return data.data || [];
};

export const crearClubCliente = async (payload) => {
    const res = await fetch(`${config.api_url}/api/fidelizacion/clientes`, {
        method: 'POST', headers: headers(), body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!data.ok) throw new Error(data.msg || 'Error al crear cliente');
    return data;
};

export const editarClubCliente = async (id, payload) => {
    const res = await fetch(`${config.api_url}/api/fidelizacion/clientes/${id}`, {
        method: 'PUT', headers: headers(), body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!data.ok) throw new Error(data.msg || 'Error al editar cliente');
    return data;
};

export const desactivarClubCliente = async (id) => {
    const res = await fetch(`${config.api_url}/api/fidelizacion/clientes/${id}`, {
        method: 'DELETE', headers: headers(),
    });
    const data = await res.json();
    if (!data.ok) throw new Error(data.msg || 'Error al eliminar cliente');
    return data;
};
